/* unplugin-vue-components disabled */import script from "./eImage.vue?vue&type=script&setup=true&lang=js"
export * from "./eImage.vue?vue&type=script&setup=true&lang=js"

import "./eImage.vue?vue&type=style&index=0&id=3a71c7dc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a71c7dc"]])

export default __exports__